import { createStore } from 'redux';
import reducers from './reducers';
import { persistStore } from 'redux-persist';
import { devToolsEnhancer } from 'redux-devtools-extension';

const configureStore = (initialState = undefined) => {
  const store = createStore(reducers, initialState, devToolsEnhancer({}));

  return store;
};

export const Store = configureStore();
export const Persistor = persistStore(Store);
